import { Text } from "@chakra-ui/react"
import React from "react"
import { Address } from "~/interfaces/entities/Address"
import AdressCountry from "./AddressCountry"
import { getAddressLines } from "./addressFormatter"

interface Props {
  address: Address
}

const AddressCA: React.FC<Props> = ({ address }) => {
  const addressLine = getAddressLines(address)
  const { name, postcode, city, state, country } = address

  const postCodeUpperCase = postcode.toUpperCase()
  const formattedPostCode =
    postCodeUpperCase.length === 6 // Standard CA postcode format: A1B C1D
      ? postCodeUpperCase.slice(0, 3) + " " + postCodeUpperCase.slice(3)
      : postCodeUpperCase

  return (
    <Text>
      {!!name && <Text>{name}</Text>}
      {addressLine}, {city} {state} {formattedPostCode}
      <AdressCountry code={country} />
    </Text>
  )
}

export default AddressCA
